class MATAProductsFilter {
  constructor( index, element ) {
		this.$index = index
		this.$element = $(element)

		this.selectors = {
			filters: '[data-filter]',
			items: '.product-grid__item',
			carousel: '.carousel__slides',
			noresults: '.no-results'
		}

		this.init()
  }

  init() {
		this.filterProductGridItems()
  }

	filterProductGridItems() {
		const $items = this.$element.find(this.selectors.items)
		const $filters = this.$element.find(this.selectors.filters)
		const $results = this.$element.find(this.selectors.noresults)
		
		let matches = 0

		$filters.each(function() {
			$(this).on('click', function() {
				let activeFilter = $(this).data('filter').trim()

				$(this).addClass('is-selected')
				$(this).siblings().removeClass('is-selected')

				$items.each(function() {
					$(this).hasClass(activeFilter) ? $(this).removeClass('hidden') : $(this).addClass('hidden')
					$(this).is(':visible') && matches++
				})

				matches === 0 ? $results.removeClass('hidden') : $results.addClass('hidden')
				matches = 0
			})
		})
	}
}